import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useGlobal } from 'reactn';
import api from '../../api';
import sendIcon from '../assets/sendIcon.png';
import Button from '../common/button/Button';
import Card from '../common/card/Card';
//import Form, { Input } from '../common/form/Form';
import { Alert } from 'antd';

const ForgotCredentials = () => {
  const [forgotCredsRes] = useGlobal('ForgotCreds_Response');
  const [emailSent, setEmailSent] = useState(null);

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const { register, handleSubmit, formState: {errors}, control } = useForm();
  
  const onSubmit = async ({ email }) => {
    setLoading(true);
    // delay feedback by at least 1 second
    setTimeout(async () => {
      const sentCredentials = await api.forgotCredentials(email);
      if (sentCredentials.error) {
        setErrorMessage(sentCredentials.error);
        setLoading(false);
        setEmailSent(false);
        return;
      }
      setEmailSent(sentCredentials.msg);
      setEmailSent(true);
    }, 1000);
  };

  const renderForgotPassword = () => {
    return (
      <Card
        className="w-full lg:max-w-2xl"
        backgroundClass="bg-white"
        title="MCWA Customer Portal Forgot Password"
        titleClassName="text-center justify-center"
      >
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col"          
        >
          <label  htmlFor="email" className="text-xs  text-white">Email</label>      
          <input type="email" id="email" className="ant-input my-6 h-16 border-blue-light" placeholder="Email" 
          {...register("email", {required: true})}
          aria-invalid={errors.email ? "true" : "false"}                
          />
            <div className='text-red-600'>
             {errors.email &&  <span> Email is required</span>}
            </div>

            {errors.email &&  
             <p role="alert">{errors.email?.message} </p>
            }

          <Button loading={loading} htmlType="submit">
            Send
          </Button>
            {errorMessage && (
              <Alert  description={errorMessage} type="error" role="alert"> 
              </Alert>                            
            )}
        </form>
        
        <div className="mt-4 text-center">
          <p className="font-bold">Know your password?</p>
          <Link className="text-black" to="/auth/signin">
            Sign In &rsaquo;
          </Link>
        </div>
      </Card>
    );
  };

  const renderConfirmationEmail = () => {
    if (forgotCredsRes && !forgotCredsRes.error)
      return (
        <Card
          className="w-full lg:max-w-2xl"
          backgroundClass="bg-white text-center"
          title="MCWA Customer Portal Forgot Password"
          padded
        >
          <img src={sendIcon} alt="send-icon" className="mx-auto" />
          <h1>Sent!</h1>
          <p>
            If you have an account with us we have sent you an email to change
            your password.
          </p>
          <Link to="/auth/signin" className="text-black">
            Return to Signin &rsaquo;
          </Link>
        </Card>
      );
  };

  return !emailSent ? renderForgotPassword() : renderConfirmationEmail();
};

export default ForgotCredentials;
